// Smooth in-page navigation that cooperates with the Lenis instance.
export const scrollToId = (href) => {
  const target = document.querySelector(href);
  if (!target) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(target, { offset: -10, duration: 1.4 });
  } else {
    target.scrollIntoView({ behavior: "smooth" });
  }
};

export const scrollToTop = () => {
  if (window.__lenis) window.__lenis.scrollTo(0, { duration: 1.2 });
  else window.scrollTo({ top: 0, behavior: "smooth" });
};
